import { Icon } from "@dmm-com/rocket-web-ui-library";
import { useMemo } from "react";
import * as Styled from "./style";
import { isVideoLegacySeason, isVideoSeason } from "~/components/blocks/product/type-guard";
import type { G_GetVideoQuery } from "~/lib/graphql";
import { G_VideoContentType } from "~/lib/graphql";

const HELP_URL = {
  DMM_TV: "https://support.dmm.com/dmm-tv/article/47590",
  VOD_2D: "https://support.dmm.com/dmm-tv/article/47681",
  VOD_VR: "https://support.dmm.com/dmm-tv/article/47593",
} as const;

type ProductHelpBannerProps = { videoData: G_GetVideoQuery["video"] };

export const ProductHelpBanner = (props: ProductHelpBannerProps) => {
  const { videoData } = props;

  const linkTitle = useMemo(() => {
    if (isVideoSeason(videoData)) return "動画の再生方法について";

    if (isVideoLegacySeason(videoData)) {
      const {
        content: { contentType },
      } = videoData;

      return contentType === G_VideoContentType.Vod_2D ? "グラビア動画の再生方法について" : "VR動画の再生方法について";
    }

    return;
  }, [videoData.id]);

  const helpUrl = useMemo(() => {
    if (isVideoSeason(videoData)) return HELP_URL.DMM_TV;

    if (isVideoLegacySeason(videoData)) {
      const {
        content: { contentType },
      } = videoData;

      return contentType === G_VideoContentType.Vod_2D ? HELP_URL.VOD_2D : HELP_URL.VOD_VR;
    }

    return;
  }, [videoData.id]);

  if (linkTitle === undefined || helpUrl === undefined) return null;

  return (
    <Styled.AnchorHelpBannerRoot href={helpUrl}>
      <Styled.SpanText>{linkTitle}</Styled.SpanText>
      <Icon name="arrowRight" size="M" color="GRAY900" />
    </Styled.AnchorHelpBannerRoot>
  );
};
